<template>  
  <v-dialog id="dialog" v-model="dialog" max-width="850px">
    <template v-slot:activator="{ on, attrs }">    
      <v-list-item-title 
        v-bind="attrs"  
        v-on="on"
      >
        Configure
      </v-list-item-title>      
    </template>

    <v-card>
      <v-card-title class="ml-3">Configure CLI</v-card-title>
      <v-card-text class="mt-2">
        <span class="ml-3" v-if="namespace">To configure synpse CLI for the current project and namespace:</span>
        <span class="ml-3" v-else>To configure synpse CLI for the current project:</span>        
        <v-container fluid class="mt-2 mb-2">        

          <markup
            language="bash"
            :code="command"
            :inline="false"
          ></markup>
          
        </v-container>

        <span class="ml-3">To list devices, run:</span>
        
        <v-container fluid class="mt-2 mb-2">
          <markup
              language="bash"
              code="synpse devices"
              :inline="false"
            ></markup>
        </v-container>

        <span class="ml-3">To SSH into the device:</span>
        
        <v-container fluid class="mt-2 mb-2">
          <markup
              language="bash"
              :code="sshCommand"
              :inline="false"
            ></markup>
        </v-container>

        <span class="ml-3">To view applications:</span>
        
        <v-container fluid class="mt-2">
          <markup
              language="bash"
              :code="psCommand"
              :inline="false"
            ></markup>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false" class="primary--text"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
.addbtn {
  margin: 0px;
  top: auto;
  right: 20px;
  bottom: 20px;
  left: auto;
  position: fixed;
  z-index: 1;
}
</style>

<script>
import Markup from '../helpers/Markup';

export default {
  components: {
    Markup
  },
  props: {
    project: Object,
    namespace: Object,
    device: String,
    namespaces: Array,
  },
  data() {
    return {
      dialog: false      
    }
  },

  computed: {
    command() {
      if (this.namespace) {
        return `synpse project select ${this.project.name} --namespace ${this.namespace.name}`
      }
      // Get the first namespace
      if (this.namespaces.length > 0) {
        return `synpse project select ${this.project.name} --namespace ${this.namespaces[0].name}`
      }
      return `synpse project select ${this.project.name}`
    },
    psCommand() {          
      if (this.namespace) {
        return `synpse --project ${this.project.name} --namespace ${this.namespace.name} ps`
      }
      if (this.namespaces.length > 0) {
        return `synpse --project ${this.project.name} --namespace ${this.namespaces[0].name} ps`
      }      
      
      return `synpse --project ${this.project.name} ps`
    },
    sshCommand() {
      if (this.device) {
        return `synpse --project ${this.project.name} ssh ${this.device}`
      }
      return `synpse --project ${this.project.name} ssh <device name>`
    }
  },

  methods: {
    close() {
      // closing dialog
      // this.$emit('clicked', '')
      this.dialog = false
    }
  }
}
</script>
